/** The URL parameter a fix link uses to name the field it was sent to fix. */
export const FIX_FIELD_PARAM = 'fixField';

const HIGHLIGHT_CLASS = 'ring-primary';
// Inline and important: the app removes every focus ring with !important.
const HIGHLIGHT_SHADOW =
  '0 0 0 2px hsl(var(--background)), 0 0 0 4px hsl(var(--primary))';

/**
 * Scrolls to, focuses and outlines the element with `id` once it renders,
 * giving up after `timeoutMs`. The outline goes when the field loses focus.
 * Returns a cancel function for an effect cleanup.
 */
export function focusFixField(id: string, timeoutMs = 5000): () => void {
  const started = Date.now();
  let frame = 0;
  const attempt = () => {
    const element = document.getElementById(id);
    if (!element) {
      if (Date.now() - started < timeoutMs) {
        frame = requestAnimationFrame(attempt);
      }
      return;
    }
    const previousShadow = element.style.getPropertyValue('box-shadow');
    element.scrollIntoView?.({ block: 'center' });
    element.focus({ preventScroll: true });
    element.classList.add(HIGHLIGHT_CLASS);
    element.style.setProperty('box-shadow', HIGHLIGHT_SHADOW, 'important');
    element.addEventListener(
      'blur',
      () => {
        element.classList.remove(HIGHLIGHT_CLASS);
        element.style.setProperty('box-shadow', previousShadow);
      },
      { once: true }
    );
  };
  frame = requestAnimationFrame(attempt);
  return () => cancelAnimationFrame(frame);
}
